import React, { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import { string, object } from 'yup';
import InputField from './InputField';
import { post } from '../Services/http';
import { catchErrorNoDispatch } from '../Actions/Error.action';
import { handleApiErrors } from '../Services/Error.service';

function LinkIlok() {
    const dispatch = useDispatch();
    const linkIlok = useSelector((state) => state.linkIlok);
    const [showLinkExisting, setShowLinkExisting] = useState(!linkIlok.done && linkIlok.existingILokIds && linkIlok.existingILokIds.length > 0);
    const [showCreateNew, setShowCreateNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(linkIlok.done);
    const [selectedIlokId, setSelectedIlokId] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [errors, setErrors] = useState([])

    const iLokIdValidationSchema = object().shape({
        selectedIlokId: string()
            .required(translate('js.ilok.link.validation.ilokidnotempty'))
    });

    const submitLinkExisting = () => {
        setSubmitting(true);

        iLokIdValidationSchema.validate({
            selectedIlokId,
        })
        .then(async () => {
            post('/api/user/linkExistingIlokId', {selectedIlokId, redirectUrl: linkIlok.redirectUrl})
                .then((response) => response.json())
                .then((result) => {
                    window.location.href = result.url;
                })
                .catch((ex) => {
                    catchErrorNoDispatch(ex, (error) => {
                        dispatch(handleApiErrors(error));
                        setErrors(error);
                    })
                    setSubmitting(false);
                });
        })
        .catch((error) => {
            setErrors(errorReducer(errors, {type: '', payload: {error}}));
            setSubmitting(false);
        })
    }
    
    const submitCreateNew = () => {
        setSubmitting(true);

        post('/api/user/createNewIlokAccount', linkIlok.userEmail)
            .then(() => {
                setShowCreateNew(false);
                setShowConfirm(true);
            })
            .catch((ex) => {
                catchErrorNoDispatch(ex, (error) => {
                    dispatch(handleApiErrors(error));
                    setErrors(error);
                })
                setSubmitting(false);
            });
    }

    return (
        <Fragment>
            <div className="link-ilok-page__wrapper">
                {showConfirm ? (
                    <div className="link-ilok-page__done">
                        <i className="icon-check_circle"></i>
                        <h1>{linkIlok.confirmationTitle}</h1>
                        <p>{linkIlok.confirmationText}</p>
                        <a href={linkIlok.redirectUrl} className="button">{translate('js.ilok.done.button.continue')}</a>
                    </div>
                ) : (
                    <Fragment>
                        <img src={linkIlok.image.url} alt={linkIlok.image.altText} />
                        {showLinkExisting ? (
                            <Fragment>
                                <h1>{linkIlok.linkExistingILokTitle}</h1>
                                {(linkIlok.existingILokIds && linkIlok.existingILokIds.length > 0) &&
                                    <div>
                                        {linkIlok.existingILokIds.length === 1 ? (
                                            <p>{translate('js.ilok.link.foundaccount')}</p>
                                        ) : (
                                            <p>{translate('js.ilok.link.foundaccounts')}</p>
                                        )}
                                        <ul>
                                            {linkIlok.existingILokIds.map((ilokId) => (
                                                <li key={ilokId}>
                                                    <button className="button button__link" disabled={submitting} onClick={() => setSelectedIlokId(ilokId)}>{ilokId}</button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                }
                                <form>
                                    <InputField
                                        id='selectedIlokId'
                                        name='selectedIlokId'
                                        type='text'
                                        value={selectedIlokId}
                                        onChange={(value) => setSelectedIlokId(value)}
                                        disabled={submitting}
                                        errors={errors}
                                        label={translate('js.ilok.link.label.userid')}
                                    />
                                    <p>{linkIlok.linkExisitingILokInfoText}</p>
                                    <button type="button" className={`button button--full-width ${submitting ? 'loading' : ''}`} disabled={submitting} onClick={() => submitLinkExisting()}>
                                        <span>{translate('js.ilok.link.button.linkaccount')}</span>
                                        <span className="spinner spinner--light spinner--small"></span>
                                    </button>
                                </form>
                                <button onClick={() => setShowLinkExisting(false)} className="button button__link" disabled={submitting}>
                                    {translate('js.ilok.button.changeoption')}
                                </button>
                            </Fragment>
                        ) : (
                            <Fragment>
                                {showCreateNew ? (
                                    <Fragment>
                                        <h1>{linkIlok.newILokTitle}</h1>
                                        <label className="link-ilok-page__input-create">
                                            <span>{translate('js.ilok.create.label')}</span>
                                            <input disabled value={linkIlok.userEmail} />
                                        </label>
                                        <div className="link-ilok-page__info"><i className="icon-info_circle"></i> {linkIlok.newILokInfoText}</div>
                                        <button type="button" className={`button button--full-width ${submitting ? 'loading' : ''}`} disabled={submitting} onClick={() => submitCreateNew()}>
                                            <span>{translate('js.ilok.create.button')}</span>
                                            <span className="spinner spinner--light spinner--small"></span>
                                        </button>
                                        <button onClick={() => setShowCreateNew(false)} className="button button__link" disabled={submitting}>
                                            {translate('js.ilok.button.changeoption')}
                                        </button>
                                    </Fragment>
                                ) : (
                                    <Fragment>
                                        <h1>{linkIlok.title}</h1>
                                        <p>{linkIlok.iLokInfoText}</p>
                                        <button onClick={() => setShowCreateNew(true)} className="button button--full-width">{translate('js.ilok.button.create')}</button>
                                        <button onClick={() => setShowLinkExisting(true)} className="button button--full-width button__outline">{translate('js.ilok.button.link')}</button>
                                        {linkIlok.forceLinkIlok &&
                                            <a href="@Model.RedirectUrl" className="button button__link">{translate('js.ilok.button.later')}</a>
                                        }
                                    </Fragment>
                                )}
                            </Fragment>
                        )}
                    </Fragment>
                )}
            </div>
            {showCreateNew &&
                <p className="link-ilok-page__footer" dangerouslySetInnerHTML={ {__html: linkIlok.iLokTermsText} } />
            }
        </Fragment>
    );
}

export default LinkIlok;
